<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-basket</v-icon>{{$t('order.order')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <OrderForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import OrderForm from '../../components/order/FormCreate.vue';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Order';

const { mapFields } = createHelpers({
  getterType: 'order/getField',
  mutationType: 'order/updateField'
});

export default {
  name: 'OrderCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    OrderForm,
    Toolbar
  },
  data() {
    return {
      item: {
        quantity: 1
      },
      defaultvalues: {

      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'uploaded','created', 'violations']),

  },
  methods: {
    ...mapActions('order', ['create','upload', 'reset']),

  }

};
</script>
